// extracted by mini-css-extract-plugin
export default {"container":"BaseModal_container__r2d0d","backdrop":"BaseModal_backdrop__nOAmS"};